import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './BaseAlert.module.css';

export enum AlertTypes {
  warning = 'warning',
}

type Props = PropsWithChildren<{
  className?: string;
  type: AlertTypes;
}>;

const BaseAlert = ({ children, className, type }: Props): JSX.Element => (
  <div className={cn(styles.alert, className, styles[type])}>
    <p className={styles.alert__message}>{children}</p>
  </div>
);

export default BaseAlert;
